import { NavLink, useLocation } from "react-router-dom";
import styles from "./Layout.module.scss";
import logo from "@assets/redesign/logoMenu.svg";
import wlpLogo from "../WLP202603/assets/wattlord-logo-menu.svg";
import { useIntl } from "react-intl";
import { Social } from "./Social";
import classNames from "classnames";
import { Badge } from "antd";
import { SHOW_LOGS, SITE_KIND, WLP202603 } from "../../config";

type MenuProps = {
  isAdmin: boolean;
  items: MenuItem[];
};

type MenuItem = {
  location?: string;
  id?: string;
  onlyAdmin?: boolean;
  value?: string;
  small?: boolean;
};

function Menu(props: MenuProps) {
  const { formatMessage } = useIntl();
  const location = useLocation();

  const renderNav = (item: MenuItem, index: number) => {
    if (item.location) {
      if (item.onlyAdmin && !props.isAdmin) {
        return null;
      }

      if (item.id === "menu.messenger" || item.id === "menu.notifications") {
        return null;
      }

      return (
        <NavLink to={item.location} key={item.location || index}>
          <div
            className={classNames(styles.item, styles.link, {
              [styles.selected]: location.pathname === item.location,
              [styles.small]: item.small,
            })}
          >
            <span>{item.id ? formatMessage({ id: item.id }) : item.value}</span>
            {item.id === "menu.messenger" && <Badge size="small" count={100} />}
          </div>
        </NavLink>
      );
    }

    return <div key={index} className={styles.separator}></div>;
  };

  return (
    <aside className={styles.navigation}>
      {SHOW_LOGS && <div className={styles.debug}>ver:mobx</div>}
      <div className={styles.head}>
        <img src={WLP202603 ? wlpLogo : logo} alt={WLP202603 ? "Wattlord" : ""} />
      </div>
      <nav className={styles.menu}>
        {props.items.map((item, index) => renderNav(item, index))}
        <div className={styles.item}>
          <Social />
        </div>
        <span className={styles.item}>&copy;{`${SITE_KIND}`} {new Date().getFullYear()}</span>
      </nav>
    </aside>
  );
}

export { Menu };
